import React from 'react'
import { ArrowBack } from '@material-ui/icons'
import { AppBar, DialogTitle, IconButton, makeStyles, Typography } from '@material-ui/core'

const useStyle = makeStyles((theme) => ({
  appBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 16,
    padding: '0 8px',
  },
  title: {
    padding: '27px 8px',
  },
  back: {
    color: theme.palette.primary.contrastText,
  },
}))

export default function MuiAppBar({ title, titleAlign = 'center', onClose }) {
  const classes = useStyle()

  return (
    <DialogTitle className={classes.title}>
      <AppBar className={classes.appBar}>
        {onClose && (
          <IconButton size="small" onClick={onClose}>
            <ArrowBack className={classes.back} />
          </IconButton>
        )}
        <Typography
          variant="h6"
          style={{
            flexGrow: 1,
            alignSelf: 'center',
            textAlign: titleAlign,
          }}
        >
          {title}
        </Typography>
        {onClose && (
          <IconButton disabled style={{ visibility: 'hidden' }}>
            <ArrowBack className={classes.back} />
          </IconButton>
        )}
      </AppBar>
    </DialogTitle>
  )
}
